import z from "zod";
import { SUPPORTED_CONNECTOR_PROTOCOL_VERSION } from "./protocol.js";
export const ConnectorOAuthRequestGetCapabilitiesSchema = z.object({
    kind: z.literal("getCapabilities"),
});
export const ConnectorOAuthRequestAtlassianExchangeSchema = z.object({
    kind: z.literal("atlassianExchange"),
    connectionRef: z.string().min(1),
    code: z.string().min(1),
    redirectUri: z.string().url(),
    expectedSiteUrl: z.string().url().optional(),
});
export const ConnectorOAuthRequestGitHubInstallExchangeSchema = z.object({
    kind: z.literal("githubInstallExchange"),
    connectionRef: z.string().min(1),
    code: z.string().min(1),
    installationId: z.string().min(1),
    redirectUri: z.string().url(),
});
export const ConnectorOAuthRequestPayloadSchema = z.discriminatedUnion("kind", [
    ConnectorOAuthRequestGetCapabilitiesSchema,
    ConnectorOAuthRequestAtlassianExchangeSchema,
    ConnectorOAuthRequestGitHubInstallExchangeSchema,
]);
export const ConnectorTransportOAuthRequestSchema = z.object({
    protocolVersion: z.literal(SUPPORTED_CONNECTOR_PROTOCOL_VERSION),
    kind: z.literal("oauthRequest"),
    requestId: z.string().uuid(),
    payload: ConnectorOAuthRequestPayloadSchema,
});
export const ConnectorOAuthCapabilitiesSchema = z.object({
    atlassian: z.object({
        configured: z.boolean(),
        clientId: z.string().optional(),
    }),
    githubApp: z.object({
        configured: z.boolean(),
        appSlug: z.string().optional(),
    }),
});
export const ConnectorOAuthAtlassianMetadataSchema = z.object({
    cloudId: z.string().min(1),
    siteUrl: z.string().url(),
    siteName: z.string().nullable().optional(),
    accountId: z.string().min(1),
    accountName: z.string().min(1),
    accountEmail: z.string().nullable().optional(),
    scopes: z.array(z.string()),
    accessTokenExpiresAt: z.string().datetime(),
});
export const ConnectorOAuthGitHubMetadataSchema = z.object({
    installationId: z.string().min(1),
    accountLogin: z.string().min(1),
    accountName: z.string().min(1),
    accountId: z.string().min(1),
    accountType: z.enum(["User", "Organization"]),
    repositorySelection: z.enum(["all", "selected"]),
});
export const ConnectorTransportOAuthResponseSchema = z.object({
    protocolVersion: z.literal(SUPPORTED_CONNECTOR_PROTOCOL_VERSION),
    kind: z.literal("oauthResponse"),
    requestId: z.string().uuid(),
    status: z.enum(["ok", "error"]),
    capabilities: ConnectorOAuthCapabilitiesSchema.optional(),
    atlassian: ConnectorOAuthAtlassianMetadataSchema.optional(),
    github: ConnectorOAuthGitHubMetadataSchema.optional(),
    message: z.string().min(1).optional(),
});
//# sourceMappingURL=oauth.schema.js.map